import { render, staticRenderFns } from "./TipsOptions.vue?vue&type=template&id=a5cfc172&scoped=true"
import script from "./TipsOptions.vue?vue&type=script&lang=js"
export * from "./TipsOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5cfc172",
  null
  
)

export default component.exports